import { GridSelection, PackagePromo } from './types';
import { PromoCodeBySubject } from './renewalPromoCodes';

/**
 * The promo codes a payment sends, paired to the packages being bought. The payment commands take
 * the same pairs pricing took, so the amount the server recomputes matches the one shown.
 */

/** Renewal holds its packages as subjectsID -> packagesID, so the code is already paired. */
export const renewalPackagePromos = (
  packageIdBySubject: GridSelection,
  codeBySubject: PromoCodeBySubject
): PackagePromo[] =>
  Object.keys(packageIdBySubject).map((key) => {
    const subjectsId = Number(key);

    return {
      packagesId: packageIdBySubject[subjectsId],
      promoCode: codeBySubject[subjectsId] || '',
    };
  });
